import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./Modal.module.sass";
import { useForceUpdate } from "../../helpers";
import FullBackgroundLayer from "./FullBackgroundLayer/FullBackgroundLayer";
import ModalContent from "./ModalContent/ModalContent";

const Modal = (props) => {
  const [visible, setVisible] = useState(false);
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    const { triggerButtons } = props;
    if (triggerButtons) {
      initTriggerButtons();
    }
    if (props.snapToElement) {
      window.addEventListener("resize", onResize.bind(this));
    }
    if (props.open) {
      openModal();
    }
  }, []);

  const onResize = () => {
    forceUpdate();
  };

  const initTriggerButtons = () => {
    const { triggerButtons } = props;
    triggerButtons.map((buttonQuery) => {
      const button = document.querySelector(buttonQuery);
      button.addEventListener("click", clickOnTriggerButton.bind(this));
    });
  };

  const clickOnTriggerButton = (e) => {
    e.preventDefault();
    openModal();
  };

  const openModal = () => {
    setVisible(true);
    if (props.onModalOpen) {
      props.onModalOpen();
    }
  };

  const onClickBackground = () => {
    setVisible(false);
  };

  let modalClasses = styles.modal;
  if (visible) {
    modalClasses += " " + styles["modal--show"];
  }

  return (
    <div
      className={modalClasses}
      style={{ pointerEvents: visible ? "all" : "none" }}
    >
      <FullBackgroundLayer
        background={props.background}
        opacity={visible ? 0.8 : 0}
        backgroundColor={props.backgroundColor}
        clickOnBackground={
          props.closeOnBackgroundClick ? onClickBackground : null
        }
      />
      <ModalContent
        opacity={visible ? 1 : 0}
        snapToElement={props.snapToElement}
      >
        {props.children}
      </ModalContent>
    </div>
  );
};

Modal.propTypes = {
  background: PropTypes.bool,
  backgroundColor: PropTypes.string,
  closeOnBackgroundClick: PropTypes.bool,
  snapToElement: PropTypes.string,
};

Modal.defaultProps = {
  /** Add or not the background of the modal */
  background: true,
  /** In case background is true, set his color */
  backgroundColor: "rgb(0,0,0)",
  /** Enable click on background to close the overlay */
  closeOnBackgroundClick: true,
  /** Open the modal by default */
  open: false,
  /** Query to an html node which the modal should be snapped to */
  snapToElement: "",

};

export { Modal as default };
